// 物流接口 
import axios from 'axios'

// 美团取消预约订单
export function cancelOrderMt(data) {
  return axios({
    url: `/api/mtRouter/cancelOrder`,
    method: 'post',
    data
  })
}

//新版美团取消预约
export function cancelOrderMtNew(data) {
  return axios({
    url: `/api/mtOpenRouter/cancelOrder`,
    method: 'post',
    data
  })
}

// 美团预约订单信息查询
export function reserveOrderQueryMt(orderIds) {
  return axios({
    url: `/api/mtOpenRouter/reserveOrderQuery?orderIds=${orderIds}`,
    method: 'get'
  })
}

// 美团同步订单(fulfilStatus、orderId)
export function synOrderInfoMt(data) {
  return axios({
    url: `/api/oms/order/synOrderInfo`,
    method: 'post',
    params: data
  })
}

// 获取京东面单数据
export function getPlainTex(data) {
  return axios({
    url: `/api/express/jdExpress/getPlainTex`,
    method: 'post',
    params: data
  })
}